
import React from 'react';
import { connect } from 'react-redux';
import {
    Route,
    Redirect,
} from 'react-router-dom';
import { isAuthGuardActive } from '../constants/defaultValues';
import { hasValidToken } from './tokenUtils';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ component: Component, currentUser, roles = undefined,
    auth: { isAuthenticated, token, loading },
    ...rest
}) => {
    const setComponent = (props) => {
        if (isAuthGuardActive) {
            // First check: Is there a valid token in localStorage?
            const hasToken = hasValidToken();
            
            // Show loading only briefly while Redux state is initializing
            // AND we have a valid token (to prevent flicker for authenticated users)
            if (loading && hasToken) {
                return <div className="loading">Loading...</div>;
            }
            
            // If no valid token exists, redirect immediately (don't wait for loading)
            if (!hasToken) {
                return <Redirect
                    to={{
                        pathname: '/admin/login',
                        state: { from: props.location },
                    }} />
            }
            
            // Check if user is authenticated (either isAuthenticated is true OR valid token exists)
            if (isAuthenticated || hasToken) {
                if (roles) {
                    if (roles.includes(currentUser.role)) {
                        return <Component {...props} />;
                    } else {
                        return <Redirect
                            to={{
                                pathname: '/unauthorized',
                                state: { from: props.location },
                            }} />
                    }
                } else {
                    return <Component {...props} />;
                }
            } else {
                return <Redirect
                    to={{
                        pathname: '/admin/login',
                        state: { from: props.location },
                    }} />
            }
        } else {
            return <Component {...props} />;
        }

    }

    return (
        <Route
            {...rest}
            render={setComponent}
        />
    );
}
ProtectedRoute.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    currentUser: state.auth.currentUser,
    auth: state.auth
})

export default connect(mapStateToProps, null)(ProtectedRoute)
